/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { guestAddressRequestSchema } from "./guestAddressRequestSchema.ts";
import { guestAddressSchema } from "./guestAddressSchema.ts";

export const deliveryAddressesCreateStatus201Schema = guestAddressSchema;

export const deliveryAddressesCreateStatus400Schema = errorResponseSchema;

export const deliveryAddressesCreateResponseSchema = z.union([deliveryAddressesCreateStatus201Schema, deliveryAddressesCreateStatus400Schema]);

export const deliveryAddressesCreateDataSchemaJson = guestAddressRequestSchema;

export const deliveryAddressesCreateDataSchemaXml = guestAddressRequestSchema;

export const deliveryAddressesCreateDataSchema = z.union([deliveryAddressesCreateDataSchemaJson, deliveryAddressesCreateDataSchemaXml]);
